<div class="grid-page-container">

  <div class="toolbar" *ngIf="showFilter || showAdd">
    <div class="search-field" *ngIf="showFilter">
      <input
        type="text"
        placeholder="{{'search' | translate}}..."
        [value]="filterText"
        (input)="onFilterTextChanged($any($event.target).value)"
      />
    </div>

    <span class="toolbar-spacer"></span>

    <button *ngIf="showAdd" mat-button class="main-button" (click)="addItem.emit()">
      <mat-icon>add</mat-icon> {{'FORM.BTN_CREATE' | translate}}
    </button>
  </div>

  <div class="grid-wrapper">
    <div *ngIf="loading" class="loading-overlay">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <ag-grid-angular
      class="ag-theme-alpine"
      [localeText]="localeText"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged()"
      (rowClicked)="onRowClicked($event.data)"
    ></ag-grid-angular>

    <div class="floating-actions" *ngIf="selectedRows.length > 0">
      <button
        *ngIf="showMultiEdit"
        mat-fab
        extended
        class="floating-edit-btn"
        (click)="openMultiEdit()"
        matTooltip="{{ multiEditLabelKey | translate}}">
        <mat-icon>group</mat-icon>
        <span>{{ multiEditLabelKey | translate }} ({{ selectedRows.length }})</span>
      </button>

      <button
        mat-fab
        class="floating-delete-btn"
        (click)="deleteSelected()"
        matTooltip="{{'FORM.BTN_DELETE' | translate}}">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

</div>
